var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-title"},[_c('v-icon',{staticClass:"mr-2",staticStyle:{"font-size":"1.1em"}},[_vm._v("mdi-pound")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }